import React from "react";

import { isProduct, ProductId } from "multitenancy";

import { permitionsCrud } from "../../../features/cruds";
import { ImportCertificate } from "../../../features/ImportCertificate";
import { usePermissions } from "../../../hooks/permission";
import api from "../../../services/api";
import { FORMS_ADMIN } from "../../../utils/entities/permission";

export const CustomerCertificate: React.FC = () => {
  const { read, create, edit } = usePermissions(FORMS_ADMIN.CERTIFICATE);

  const permitions: permitionsCrud = {
    toCreate: create,
    toEdit: edit,
    toRead: read,
    inactivate: false,
  };

  const getProductName = () => {
    const isInquerito = isProduct(ProductId.Inquerito);
    if (isInquerito) {
      return "Kenta Inquérito";
    }
    const isCartorio = isProduct(ProductId.Cartorio);
    if (isCartorio) {
      return "Kenta Cartório";
    }
    return "Kenta Audiências";
  };

  return (
    <ImportCertificate
      api={api}
      projectName={getProductName()}
      title="Certificado"
      permissions={permitions}
    />
  );
};
